




























// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import Edit from '@/components/administration/piscine/edit/EditPiscineAdresse.vue'
import { AloPiscine, getDefaultAloPiscine } from '@/models/alo/AloPiscine';
import { LatLng, latLng } from 'leaflet'
import { LMap, LTileLayer, LMarker, LTooltip } from 'vue2-leaflet'

@Component({
  name: 'ReadPiscineAdresse',    
   props: {
    piscine:{      
      default:getDefaultAloPiscine()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit, 
    LMap,
    LTileLayer,
    LMarker,
    LTooltip}
})
export default class ReadPiscineAdresse extends Vue {
  private piscine!:AloPiscine
  private loading!:boolean
  
  private zoom = 13  
  private url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
  private attribution ='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'  

  get hasPosGps(){    
    return this?.piscine?.address?.gpsLat && this?.piscine?.address?.gpsLon
  }
  get posGps(){
    return latLng(this.piscine.address.gpsLat!,this.piscine.address.gpsLon!)
  }

  get configuration(){    
    return this.$store.myGetters.configuration
  }

  edit() { (this.$refs.edit as Edit).edit(this.piscine) }
}
